import { render } from "./NavigationSidebar.vue?vue&type=template&id=9bc7b7f8&scoped=true"
import script from "./NavigationSidebar.vue?vue&type=script&lang=js"
export * from "./NavigationSidebar.vue?vue&type=script&lang=js"

import "./NavigationSidebar.vue?vue&type=style&index=0&id=9bc7b7f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bc7b7f8"]])

export default __exports__